import type { ReactNode } from 'react'
import { type UserRole, roleSatisfies } from '@alpha-edge/shared'
import { useAuth } from '../hooks/use-auth'
import { card, colors } from './ui/styles'

interface RoleGuardProps {
  readonly roles: readonly UserRole[]
  readonly children: ReactNode
  readonly fallback?: ReactNode
}

const denied = (
  <div style={{ ...card, textAlign: 'center', marginTop: '2rem' }}>
    <h2 style={{ color: colors.danger, margin: '0 0 0.5rem' }}>Access Denied</h2>
    <p style={{ color: colors.textMuted, margin: 0 }}>You do not have permission to access this page.</p>
  </div>
)

export function RoleGuard({ roles, children, fallback = denied }: RoleGuardProps) {
  const { user } = useAuth()

  if (!user || !roleSatisfies(user.role as UserRole, roles)) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
